import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const DocumentIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 182, height = 182, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 182 182"
        fill="none"
        {...props}
      >
        <g opacity="0.5">
          <circle cx="91" cy="91" r="90" fill="#DEF0FF" stroke="#F1F9FF" strokeWidth="2" />
          <path
            d="M8.35735 160.302H176.822L173.408 167.107H11.7712L8.35735 160.302Z"
            fill="#B0D8F9"
          />
          <path
            d="M165.033 157.91C165.033 159.366 163.841 160.558 162.382 160.558H19.0184C17.5601 160.558 16.3672 159.367 16.3672 157.91L15.1744 75.5222C15.1744 74.0657 16.8904 71.2218 20.0363 71.4351L160.147 67.8099C161.977 67.7625 163.746 68.4667 165.041 69.758C166.337 71.0493 167.046 72.8151 167.003 74.6429L165.034 157.91H165.033Z"
            fill="#B0D8F9"
          />
          <path
            d="M161.78 155.368C161.78 156.747 160.651 157.877 159.271 157.877H22.3954C21.016 157.877 19.887 156.748 19.887 155.368L18.7617 74.5895L158.963 70.9504C160.248 70.9158 161.492 71.411 162.402 72.3195C163.312 73.2279 163.809 74.47 163.776 75.7558L161.779 155.369L161.78 155.368Z"
            fill="#C7E5FD"
          />
          <path
            d="M133.26 22.5425L37.0894 21.9537C33.929 21.9343 31.4012 24.5745 31.5573 27.7313L32.6136 157.892H150.197L151.135 42.2907L133.26 22.5425Z"
            fill="#F1F9FF"
          />
          <path
            d="M137.258 40.561C134.125 40.451 131.717 37.7506 131.963 34.626L133.295 21.3657L151.139 41.1431L137.258 40.5616V40.561Z"
            fill="#B0D8F9"
          />
          <g opacity="0.36">
            <path
              d="M51.0713 47.6306C58.9757 47.5923 89.3189 47.3899 96.9814 47.3389C97.9482 47.3322 98.712 48.3373 98.6701 49.5568C98.63 50.7181 97.8704 51.646 96.9504 51.6575L51.0604 52.2299C50.1763 52.2408 49.4422 51.3999 49.3669 50.2903L49.348 50.0095C49.2617 48.7402 50.0614 47.636 51.0719 47.6312L51.0713 47.6306Z"
              fill="#B0D8F9"
            />
            <path
              d="M51.0713 57.2145C58.9756 57.1762 89.3188 56.9739 96.9813 56.9228C97.9481 56.9161 98.7119 57.9212 98.67 59.1408C98.6299 60.302 97.8703 61.2299 96.9503 61.2414L51.0603 61.8138C50.1762 61.8248 49.4421 60.9838 49.3668 59.8742L49.3479 59.5935C49.2617 58.3241 50.0613 57.22 51.0719 57.2151L51.0713 57.2145Z"
              fill="#B0D8F9"
            />
            <path
              d="M52.1873 70.7214C65.5205 70.7305 116.704 70.7129 129.629 70.708C131.259 70.7074 132.582 71.7174 132.553 72.9375C132.525 74.0988 131.275 75.0224 129.723 75.0285L52.3253 75.3232C50.8347 75.3286 49.5671 74.4828 49.4018 73.372L49.3599 73.0907C49.1709 71.8201 50.4822 70.7202 52.1873 70.7214Z"
              fill="#B0D8F9"
            />
            <path
              d="M51.3494 80.7799C61.7275 80.7349 101.569 80.5077 111.63 80.4506C112.899 80.4433 113.922 81.4477 113.891 82.6679C113.861 83.8291 112.882 84.7582 111.674 84.7704L51.4253 85.3811C50.2647 85.3926 49.2846 84.5522 49.1636 83.442L49.1332 83.1613C48.9947 81.8919 50.0235 80.7866 51.3506 80.7805L51.3494 80.7799Z"
              fill="#B0D8F9"
            />
            <path
              d="M51.8349 93.9496C65.168 93.9587 116.351 93.9411 129.276 93.9362C130.906 93.9356 132.23 94.9455 132.201 96.1657C132.173 97.3269 130.923 98.2506 129.371 98.2566L51.9728 98.5513C50.4822 98.5568 49.2147 97.711 49.0494 96.6002L49.0075 96.3188C48.8185 95.0482 50.1298 93.9484 51.8349 93.9496Z"
              fill="#B0D8F9"
            />
            <path
              d="M50.6743 104.175C61.1016 104.194 101.131 104.213 111.24 104.218C112.515 104.218 113.537 105.229 113.498 106.449C113.462 107.61 112.472 108.533 111.259 108.538L50.7235 108.776C49.5574 108.781 48.5772 107.934 48.4624 106.823L48.4332 106.542C48.302 105.271 49.3405 104.173 50.6743 104.175Z"
              fill="#B0D8F9"
            />
            <path
              d="M51.1774 117.652C64.5105 117.661 115.694 117.643 128.619 117.638C130.249 117.638 131.572 118.648 131.543 119.868C131.515 121.029 130.265 121.953 128.713 121.959L51.3153 122.253C49.8248 122.259 48.5572 121.413 48.3919 120.302L48.35 120.021C48.161 118.75 49.4723 117.651 51.1774 117.652Z"
              fill="#B0D8F9"
            />
            <path
              d="M50.3723 127.756C60.7996 127.775 100.829 127.794 110.938 127.799C112.213 127.799 113.235 128.81 113.196 130.03C113.16 131.191 112.17 132.114 110.957 132.119L50.4215 132.358C49.2554 132.362 48.2752 131.515 48.1604 130.405L48.1312 130.123C48 128.853 49.0385 127.754 50.3723 127.756Z"
              fill="#B0D8F9"
            />
          </g>
          <path
            d="M73.2501 160.302H111.613C111.613 161.837 110.369 163.082 108.833 163.082H76.03C74.4947 163.082 73.2501 161.837 73.2501 160.302Z"
            fill="#DEF0FF"
          />
        </g>
      </svg>
    );
  },
);
